import {DialogHeader} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledHeader = styled(DialogHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: ${spacing * 2}px;
    `
)
